<template>
  <section class="informations">
    <Container>
      <Title tag="h2">Información Geo-cientifica</Title>
      <Row>
        <ColumnUi md="6" lg="4" class="information">
          <div class="icon-wrapper">
            <Icon svg="folder" class="information__icon" />
          </div>
          <div class="information__info">
            <h3 class="information__title">Aceldat Perú</h3>
            <span
              ><Button
                tag="a"
                href="https://www.igp.gob.pe/servicios/aceldat-peru/"
                target="_blank"
                theme="primary"
                >Conoce más</Button
              ></span
            >
          </div>
        </ColumnUi>
        <ColumnUi md="6" lg="4" class="information">
          <div class="icon-wrapper">
            <Icon svg="folder" class="information__icon" />
          </div>
          <div class="information__info">
            <h3 class="information__title">
              Repositorio Geofísico Nacional - REGEN
            </h3>
            <span
              ><Button
                tag="a"
                href="https://repositorio.igp.gob.pe/"
                target="_blank"
                theme="primary"
                >Conoce más</Button
              ></span
            >
          </div>
        </ColumnUi>
        <ColumnUi md="6" lg="4" class="information">
          <div class="icon-wrapper">
            <Icon svg="folder" class="information__icon" />
          </div>
          <div class="information__info">
            <h3 class="information__title">Biblioteca IGP</h3>
            <span
              ><Button
                tag="a"
                href="http://biblioteca.igp.gob.pe/"
                target="_blank"
                theme="primary"
                >Conoce más</Button
              ></span
            >
          </div>
        </ColumnUi>
      </Row>
    </Container>
  </section>
</template>
<script>
import Container from "@/components/ui/objects/Container";
import Button from "@/components/ui/atoms/Button";
import Icon from "@/components/ui/atoms/Icon";
import Row from "../ui/atoms/Row.vue";
import ColumnUi from "../ui/atoms/ColumnUi.vue";
import Title from "../ui/atoms/Title.vue";
export default {
  components: {
    Container,
    Button,
    Icon,
    Row,
    ColumnUi,
    Title,
  },
};
</script>
<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
@use "@/assets/styles/tools/_mixins.scss";
.informations {
  padding: variables.$spacing-l 0;
}
.information {
  display: flex;
  align-items: center;
  grid-gap: 0 1.5em;
  margin-bottom: 2em;
  .icon-wrapper {
    min-width: 100px;
    height: 100px;
    background-color: variables.$primary-color;
    border-radius: 50%;
    @include mixins.centered;
  }
  &__title {
    text-transform: uppercase;
  }
  &__info {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  &__icon {
    height: 3em;
    fill: variables.$text-inverted-color;
    margin: 0;
  }
}
@media (min-width: variables.$lg) {
  .information {
    margin-bottom: 0;
  }
}
</style>
